// Entry point for the page.
//
// The page is ONE custom element, `<valvoline-driving-sweepstakes>`, which
// composes the seven sections. Sections live under src/components/<name>/ as
// template functions — see CLAUDE.md for why they are not elements of their own.
import "./components/driving-sweepstakes/driving-sweepstakes";

// GA4. A side-effect import, and the only thing in this file that is not the
// element: /officialrules loads src/analytics.ts on its own, so both pages get
// analytics from the same module without either knowing about the other.
import "./analytics";

// GTM, landing page only: /officialrules does not load this file, which is the
// point — the client asked for it here and not there. After ./analytics so gtag's
// queue is already in place when GTM joins the shared dataLayer.
import { initTagManager } from "./lib/tag-manager";

initTagManager();

export { ValvolineDrivingSweepstakes } from "./components/driving-sweepstakes/driving-sweepstakes";
